  function delay(t, e) {
    let i = 0;
    return function (...n) {
      clearTimeout(i), (i = setTimeout(t.bind(this, ...n), e || 0));
    };
  }
  function setCookie(e, t, i) {
    var o = new Date();
    o.setTime(o.getTime() + 24 * i * 60 * 60 * 1e3);
    var n = 'expires=' + o.toUTCString();
    document.cookie = e + '=' + t + ';' + n + ';path=/';
  }
  function getCookie(e) {
    for (var n = e + '=', t = decodeURIComponent(document.cookie).split(';'), o = 0; o < t.length; o++) {
      for (var r = t[o]; ' ' == r.charAt(0); ) r = r.substring(1);
      if (0 == r.indexOf(n)) return r.substring(n.length, r.length);
    }
    return '';
  }